//Этот файл общий для бэка и фронта не админки. Должен совпадать на бэке и фронте
import { PaymentMethod, ReceivingMethod } from './def_common_api';

//Входные данные для создания заказа в Api
export interface CatalogItemBasketInputApiI {
  id: number;
  vendor_id: number;
  quantity: number;
  title: string;
  price_kopecks: number;
  unit: string;
}
export interface CatalogItemsCreateOrderInputApiI {
  catalog_items: CatalogItemBasketInputApiI[];
  //Сумма заказа (возможно со скидкой) вместе с доставкой
  order_sum_kopecks: number;
  //Сумма доставки
  delivery_sum_kopecks: number;
  //Адрес доставки
  delivery_address: string;
  //Дата доставки
  delivery_date: Date | string;
  //Комментарии курьеру
  delivery_courier_comment: string;
  //Получатель 3 лицо
  other_recipient: boolean;
  //ФИО получателя (3 лицо)
  other_recipient_name: string;
  //Тел. получателя (3 лицо)
  other_recipient_phone: string;
  checkout_phone: string;
  checkout_email: string;
  receiving_method: ReceivingMethod;
  payment_method: PaymentMethod;
  is_physical_person: boolean;
}

//Сортировка для товаров
export enum CatalogItemsSort {
  //Без сортировки
  No = 'no',
  //Сначала недорогие (сортировка по возрастанию)
  PriceAsc = 'price_asc',
  //Сначала дорогие (сортировка по убыванию)
  PriceDesc = 'price_desc',
  //Сначала актуальные (сортировка по убыванию даты изменения)
  UpdatedDesc = 'updated_desc',
  //Сортировка по фото. Сначала идут с актуальными фото
  Img = 'img',
}
